import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import * as config from 'mdoc/axios/config'

const actionsStyles = theme => ({
    root: {
        flexShrink: 0,
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing.unit * 2.5,
    },
});

class TablePaginationActions extends React.Component {
    handleFirstPageButtonClick = event => {
        this.props.onChangePage(event, 0);
    };

    handleBackButtonClick = event => {
        this.props.onChangePage(event, this.props.page - 1);
    };

    handleNextButtonClick = event => {
        this.props.onChangePage(event, this.props.page + 1);
    };

    handleLastPageButtonClick = event => {
        this.props.onChangePage(
            event,
            Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1),
        );
    };

    render() {
        const { classes, count, page, rowsPerPage, theme } = this.props;

        return (
            <div className={classes.root}>
                <IconButton
                    onClick={this.handleFirstPageButtonClick}
                    disabled={page === 0}
                    aria-label="First Page"
                >
                    {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
                </IconButton>
                <IconButton
                    onClick={this.handleBackButtonClick}
                    disabled={page === 0}
                    aria-label="Previous Page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                </IconButton>
                <IconButton
                    onClick={this.handleNextButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Next Page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                </IconButton>
                <IconButton
                    onClick={this.handleLastPageButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Last Page"
                >
                    {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
                </IconButton>
            </div>
        );
    }
}

TablePaginationActions.propTypes = {
    classes: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    theme: PropTypes.object.isRequired,
};

const TablePaginationActionsWrapped = withStyles(actionsStyles, { withTheme: true })(
    TablePaginationActions,
);


const styles = theme => ({
    root:{
        fontSize:12
    }
});
class EnhancedTableFooter extends React.Component {
    state = {
        page:this.props.page?this.props.page:1,
        rowsPerPage:this.props.rowsPerPage?this.props.rowsPerPage:config.ROWS_PER_PAGE,
        rowsPerPageOptions:config.ROWS_PER_PAGE_OPTIONS,

    };

    handleChangePage = (event, page) => {
        this.setState({ page: page });
        this.props.onChange(event,{page:page+1,rowsPerPage:this.state.rowsPerPage});
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
        this.props.onChange(event,{page:this.state.page+1,rowsPerPage:event.target.value});
    };
    labelDisplayedRows = (_ref)=>{
        let from = _ref.from,
            to = _ref.to,
            count = _ref.count;
        let lang = window.localStorage.getItem('localeId');
        switch (lang){
            case '2':
                return "第".concat(from, "到第").concat(to, "条 共 ").concat(count, "条");
            case '3':
                return "view ".concat(from, "-").concat(to, " of ").concat(count);
            default:
                return "".concat(count, " 件中 ").concat(from, " - ").concat(to, " を表示");
        }
    }

    render() {
        const { count,columnsCount,classes } = this.props;
        const { rowsPerPage, page,rowsPerPageOptions } = this.state;

        return (
            <TableFooter>
                <TableRow>
                    <TablePagination
                        classes={{
                            root:classes.root,
                            caption:classes.root,
                        }}
                        rowsPerPageOptions={rowsPerPageOptions}
                        count={count}
                        colSpan={columnsCount}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActionsWrapped}
                        labelDisplayedRows={this.labelDisplayedRows}
                        labelRowsPerPage=""
                    />
                </TableRow>
            </TableFooter>
        );
    }
}

EnhancedTableFooter.propTypes = {
    count: PropTypes.number.isRequired,
    columnsCount: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number,
    page: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
};
export default withStyles(styles)(EnhancedTableFooter);

